import helpers from 'helpers';

const mainSiteOrigin = __DEV__ ? 'https://test.shipnext.com' : 'https://shipnext.com';

export const elementsMapping = {
    cargos: {
        label: 'Cargo ref',
        canOpenOnMain: true,
        getUrl(_id) {
            return `${mainSiteOrigin}/main-deck/general/${_id}`;
        },
    },
    vessels: {
        label: 'Vessel',
    },
    ais: {
        label: 'Ais',
    },
	snpVessels: {
        label: 'Snp',
        canOpenOnMain: true,
        getUrl(_id) {
            return `${mainSiteOrigin}/fleetmonitor/spfleet/${_id}`;
        },
    },
	myVessels: {
        label: 'My vessel',
    },
	orders: {
        label: 'Tc',
        canOpenOnMain: true,
        getUrl(_id) {
            return `${mainSiteOrigin}/main-deck/tc/${_id}`;
        },
    },
	positions: {
        label: 'Position ref',
        canOpenOnMain: true,
        customId: "vessel",
        getUrl(_id) {
            return `${mainSiteOrigin}/main-deck/general/-/${_id}`;
        },
    },
	mails: {
        label: 'Email',
        getUrl(_id) {
            return `${window.location.origin}/${_id}`;
        }
    },
	mailThreads: {
        label: 'Emal thread',
    },
    mailThreadsRefNos: {
        label: 'Email thread ref'
    },
	voyageChartersDocuments: {
        label: 'Voyage Charter Documets',
    },
	timeChartersDocuments: {
        label: 'Time Charter Documets',
    },
	bookingNoteDocuments: {
        label: 'Booking Note Documets',
    },
	billOfLadingDocuments: {
        label: 'Bill of Lading Documets',
    },
};



// WEBPACK FOOTER //
// ./app/components/Issues/Issue/helpers.js